import {
  Button,
  ButtonStack,
  IconButton,
  OneColumnStack,
  Section,
  Stack,
} from "@arp/react-ndbx";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Page from "../../components/Page";
import RecordOfAnswers from "../../components/pageLevel/policyOutcome/RecordOfAnswers";
import { TRACKIFY_EVENT, URLS } from "../../config/const/enums";
import useNewBusiness from "../../hooks/useNewBusiness";
import usePreQualification from "../../hooks/usePreQualification";
import { PATH_CONTACT_CENTER } from "../../routes/paths";
import { trackifyPageChange } from "@allianz/tracking";

const UpgradeSaveConfirmation = () => {
  const navigate = useNavigate();
  const { data: outcomeData } = useNewBusiness();
  const { dataSet } = usePreQualification();

  useEffect(() => {
    trackifyPageChange(TRACKIFY_EVENT.SAVE_CONFIRMATION);
  }, []);

  return (
    <>
      <Page title={"Save confirmation"} identifier={"save-confirmation"}>
        <Section md={7} mb={4} mt={{ xs: 10, md: 8 }}>
          <Section mb={3}>
            <Typography variant="h2">Save Confirmation</Typography>
          </Section>
          <Section>
            <Typography variant="label-large-bold">
              Existing policy number: {dataSet.existingPolicyNumber}
            </Typography>
          </Section>
          <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
            <Section sx={{ maxWidth: { xs: 334 }, mb: 0 }}>
              <img
                width="100%"
                src="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/woman_laptop_headset.svg"
              ></img>
            </Section>
          </Section>

          <Section mb={3}>
            <Typography variant="h5">
              Thank you {outcomeData?.firstName}
            </Typography>
          </Section>
          <Section mb={3} sx={{ textAlign: "left" }}>
            <Typography variant="p2">
              Thank you, your assessment has been finalised and your policy has
              been amended. Your policy number and payment schedule will not
              change as a result of the amendment, however we may contact you
              with regards to any additional payment required.
            </Typography>
          </Section>
          <Section mb={3} sx={{ textAlign: "left" }}>
            <Typography variant="p2">
              We’ll also issue you with a Variation pack which will contain:
            </Typography>

            <Typography variant="p2">
              <ul>
                <li>Details on the amendment to your cover;</li>
                <li>
                  Any special terms and conditions that apply to the amendment;
                  and
                </li>
                <li>
                  A Record of Answers detailing all the information you've
                  provided.
                </li>
              </ul>
            </Typography>
            <Typography variant="p2">
              Please read through your paperwork to make sure all details are
              correct and that the cover is what you require. You must contact
              us immediately if any information in the Variation Record of
              Answers is incorrect.
            </Typography>
          </Section>
          <Section mb={3} sx={{ textAlign: "left" }}>
            <RecordOfAnswers>Variation Record of Answer</RecordOfAnswers>
          </Section>
        </Section>

        {/* Navigation Buttons  */}
        <Section mt={6}>
          <ButtonStack>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => (window.location.href = URLS.ALLIANZ_HOMEPAGE)}
            >
              CONTINUE TO ALLIANZ WEBSITE
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => (window.location.href = URLS.ALLIANZ_HOMEPAGE)}
            >
              CLOSE
            </Button>
          </ButtonStack>
          <Section mt={2}>
            <OneColumnStack>
              <Stack
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Section md={8} mt={2} ml={-4}>
                  <IconButton
                    name="Q1"
                    icon={<ArrowBackIcon />}
                    position="start"
                    label="Back"
                    variant="icon-button"
                    onClick={() => {
                      navigate(PATH_CONTACT_CENTER.ppCCPolicyOutcome);
                    }}
                  >
                    Back
                  </IconButton>
                </Section>
              </Stack>
            </OneColumnStack>
          </Section>
        </Section>
      </Page>
    </>
  );
};

export default UpgradeSaveConfirmation;
